<template>
  <v-container id="fcreate">
    <v-row>
      <v-form v-model="valid" ref="form">
        <v-container fluid>
          <v-row>
            <!-- Промокод -->
            <v-col cols="12" md="7">
              <v-autocomplete
                v-model="data.promoCodeId"
                :items="computedOrders"
                item-text="name"
                item-value="id"
                label="Промокод"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Название"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <v-col cols="12" md="7">
              <regions-select-fields
                v-model="data.regions"
                label="Доступно в регионах"
                empty-text="Доступно во всех регионах"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Краткое описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.subName"
                label="Краткое описание"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Slug -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.slug"
                label="Слаг"
                outlined
                required
                :rules="rules.slug"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Изображение -->
            <v-col cols="12" md="7">
              <upload-image
                v-model="data.image"
                color="orange"
                label="Загрузить фото"
              >
                Загрузить фото
              </upload-image>
            </v-col>
            <!-- Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.description"
                label="Описание"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Описание перед промо кодом -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.descriptionBeforePromoCode"
                label="Описание перед промо кодом"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Описание после промокода -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.descriptionAfterPromoCode"
                label="Описание после промокода"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Тег -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.h1"
                label="Тег заголовка"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Мета заголовок -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.metaTitle"
                label="Мета заголовок"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Мета Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.metaDescription"
                label="Мета описание"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Дата -->
            <v-col cols="12" md="7">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedDateFormattedMomentjs"
                    clearable
                    label="Дата"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :rules="rules.required"
                    @click:clear="data.date = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="data.date"
                  @change="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- Сохранить -->
            <v-col cols="12" md="7">
              <v-btn
                block
                class="mb-2"
                color="primary"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save"
              >
                Сохранить
              </v-btn>
              <v-btn
                block
                class="mb-2"
                color="primary"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save(false)"
              >
                Применить
              </v-btn>
              <v-btn
                block
                :loading="loading"
                :disabled="loading"
                @click.prevent="$router.push('/news')"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import UploadImage from './../../components/UploadImage'
  import rules from '@/mixins/rules'
  import RegionsSelectFields from '@/components/ui/crud/fields/RegionsSelectField.vue'

  export default {
    mixins: [rules],
    components: { UploadImage, RegionsSelectFields },
    data () {
      return {
        data: {
          promoCodeId: '',
          name: '',
          subName: '',
          slug: '',
          image: '',
          description: '',
          descriptionBeforePromoCode: '',
          descriptionAfterPromoCode: '',
          h1: 'h1',
          metaTitle: '',
          metaDescription: '',
          date: '',
          sortOrder: 0,
          status: true,
          regions: [],
        },
        dateMenu: false,
        valid: false,
        loading: false,
        snackbar: false,
        snackbarSuccess: false,
        computedOrders: [],
      }
    },
    watch: {
      orders: {
        handler () {
          const emptyOrder = { id: null, name: '-' }
          this.computedOrders = [emptyOrder, ...this.orders]
        },
        deep: true,
      },
    },
    computed: {
      ...mapState('promocodes', ['orders']),
      getId () { return this.$route.params.id },
      computedDateFormattedMomentjs () {
        return this.data.date ? moment(this.data.date).format('YY-MM-DD') : ''
      },
    },
    async created () {
      try {
        const res = await this.$store.dispatch('news/fetchSingleNews', this.getId)
        this.data = res.data.data
        this.data.promoCodeId = res.data.data?.promoCode?.id || null
        this.data.regions = res.data.data.regions.map(item => item.id)
      } catch (err) { console.error(err) }

      try {
        await this.$store.dispatch('promocodes/fetchPromocodesList', {
          limit: 10000,
          offset: 0,
          page: 0,
        })
      } catch (err) { console.error(err) }
    },
    methods: {
      async save (redirect = true) {
        const validate = await this.$refs.form.validate()

        if (validate) {
          try {
            this.loading = true
            const data = this.data

            data.sub_name = data.subName

            const res = await this.$store.dispatch('news/editNews', { data: data, id: this.getId })
            if (res.status === 200 && redirect) {
              this.$router.push('/news')
            } else {
              this.snackbarSuccess = true
              setTimeout(() => {
                this.snackbarSuccess = false
              }, 3000)
            }
          } catch (e) { console.log(e) }

          this.loading = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
